import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Projects } from './components/Projects';
import { CustomersPartners } from './components/CustomersPartners';
import { Team } from './components/Team';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { AdminLogin } from './pages/AdminLogin';
import { AdminHome } from './pages/AdminHome';
import { AdminServices } from './pages/AdminServices';
import { AdminProjects } from './pages/AdminProjects';
import { AdminCompany } from './pages/AdminCompany';
import { AdminActivities } from './pages/AdminActivities';
import { AdminCustomers } from './pages/AdminCustomers';
import { AdminPartners } from './pages/AdminPartners';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminContent from './pages/AdminContent';
import { Toaster } from './components/ui/sonner';

const PublicWebsite = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <CustomersPartners />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Website */}
          <Route path="/" element={<PublicWebsite />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminHome />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/content" element={<AdminContent />} />
          <Route path="/admin/services" element={<AdminServices />} />
          <Route path="/admin/projects" element={<AdminProjects />} />
          <Route path="/admin/company" element={<AdminCompany />} />
          <Route path="/admin/activities" element={<AdminActivities />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/admin/partners" element={<AdminPartners />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;